import { ListingState } from '../../../data/types/listings';
import {
  CLEAR,
  SET_ALL_ATTRIBUTES,
  SET_DATA,
  SET_PRODUCT_TYPE,
  SET_USER_TYPE,
} from './create_listing_actions';

export const initialState: ListingState = {
  productType: 0,
  userType: 0,
  data: {
    attributes: [],
    price: '',
    original_price: '',
    in_stock: false,
    images: [],
    imagesList: [],
    cover_image_id: null,
    name_en: '',
    name_ar: '',
    description_en: '',
    description_ar: '',
    whats_included: '',
    barcode: '',
    // time_to_ship: '',
    category_id: 0,
    category: undefined,

    weight: '',
    length: '',
    height: '',
    width: '',

    flammable: false,
    fragile: false,
    keep_dry: false,

    select_attrs: [],
    numeric_attrs: [],
    boolean_attrs: [],
    combinations_table: [],
    prev_combinations_table: [],
    list_on_approval: true,
    is_used: false,
    parent_listing_id: null,
    id_of_draft_to_delete: null,
    listing_type: 'public_listing',
    selectedImages: {},
    notToUploadImages: [],
    applied_promotion: undefined,
  },
  all_attributes: [],
  error_fields: {
    price: '',
    in_stock: false,
    images: [],
    imagesList: [],
    cover_image_id: 0,
    name_en: '',
    name_ar: '',
    description: '',
    whats_included: '',
    barcode: '',
    time_to_ship: '',
    category_id: 0,

    weight: '',
    length: '',
    height: '',
    width: '',

    flammable: false,
    fragile: false,
    keep_dry: false,
    selectedImages: {},
    select_attrs: [],
    numeric_attrs: [],
    boolean_attrs: [],
    combinations_table: [],
    list_on_approval: true,
    is_used: false,
    parent_listing_id: null,
    id_of_draft_to_delete: null,
    listing_type: 'public_listing',
  },
};

export const reducer = (state = initialState, action: any) => {
  if (action.type === SET_DATA) {
    return { ...state, data: action.payload };
  }
  if (action.type === SET_PRODUCT_TYPE) {
    return { ...state, productType: action.payload };
  }
  if (action.type === SET_USER_TYPE) {
    return { ...state, userType: action.payload };
  }
  if (action.type === SET_ALL_ATTRIBUTES) {
    return { ...state, all_attributes: action.payload };
  }
  if (action.type === CLEAR) {
    return null;
  }
  return state;
};
